var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNotificationsOrange = function SvgIconNotificationsOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-notifications",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "area",
    fill: "#6a6a6a",
    opacity: 0.002,
    d: "M0 0h36v36H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(-653.26 -260.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M671.26 291.019a4 4 0 0 1-3.874-5 1 1 0 1 1 1.937.5 2 2 0 1 0 3.937.5 1.977 1.977 0 0 0-.063-.5 1 1 0 1 1 1.938-.5 4.006 4.006 0 0 1-3.875 5Z",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M681.26 287.019h-20a1 1 0 0 1-.868-1.5l3.868-6.769v-4.734a7 7 0 0 1 14 0v4.734l3.868 6.769a1 1 0 0 1-.868 1.5Zm-18.277-2h16.553l-3.144-5.5a1.006 1.006 0 0 1-.132-.5v-5a5 5 0 0 0-10 0v5a1.006 1.006 0 0 1-.132.5Z",
    fill: "#ff8500"
  }))));
};
export { SvgIconNotificationsOrange as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1ub3RpZmljYXRpb25zIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDM2IDM2Ij4KICA8cmVjdCBpZD0iYXJlYSIgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSIjNmE2YTZhIiBvcGFjaXR5PSIwLjAwMiIvPgogIDxnIGlkPSJiZWxsIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjUzLjI2IC0yNjAuMDE5KSI+CiAgICA8cGF0aCBpZD0iUGF0aF8xNTUiIGRhdGEtbmFtZT0iUGF0aCAxNTUiIGQ9Ik02NzEuMjYsMjkxLjAxOWE0LDQsMCwwLDEtMy44NzQtNSwxLDEsMCwxLDEsMS45MzcuNSwyLDIsMCwxLDAsMy45MzcuNSwxLjk3NywxLjk3NywwLDAsMC0uMDYzLS41LDEsMSwwLDEsMSwxLjkzOC0uNSw0LjAwNiw0LjAwNiwwLDAsMS0zLjg3NSw1WiIgZmlsbD0iI2ZmY2UwMCIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTU2IiBkYXRhLW5hbWU9IlBhdGggMTU2IiBkPSJNNjgxLjI2LDI4Ny4wMTloLTIwYTEsMSwwLDAsMS0uODY4LTEuNWwzLjg2OC02Ljc2OXYtNC43MzRhNyw3LDAsMCwxLDE0LDB2NC43MzRsMy44NjgsNi43NjlhMSwxLDAsMCwxLS44NjgsMS41Wm0tMTguMjc3LTJoMTYuNTUzbC0zLjE0NC01LjVhMS4wMDYsMS4wMDYsMCwwLDEtLjEzMi0uNXYtNWE1LDUsMCwwLDAtMTAsMHY1YTEuMDA2LDEuMDA2LDAsMCwxLS4xMzIuNVoiIGZpbGw9IiNmZjg1MDAiLz4KICA8L2c+Cjwvc3ZnPgo=";